<div>
    <div class="mailtabcontainer col-lg-12">        
            <div class="float-left col-lg-2 mailTab mailTabActive">Mail</div>
            <!-- <div class="float-right col-lg-2 mailTab">Calendar</div> -->
    </div>

    <div class="clearfix"></div>
         

    <div class="left-panel col-lg-2 text-center col-xl-2 float-left">
        
        <button class="btn btn-sm btn-primary new-email" (click)="composeEmail('new', null)"><i class="bi bi-pencil"></i> &nbsp;Compose</button>


        <div class="list-group">
            <div class="list-group-item custom-list inboxfont" [ngClass]="{'active': currentSelected == 'INBOX'}" title="Inbox" (click)="mailFunc('INBOX')"><span>Inbox</span> <span>{{emailCounts?.INBOX}}</span> </div>
            <div class="list-group-item custom-list inboxfont" [ngClass]="{'active': currentSelected == 'SENT'}" title="Sent" (click)="mailFunc('SENT')"><span>Sent</span> <!--<span> <span>26</span>--></div>
            <div class="list-group-item custom-list inboxfont" [ngClass]="{'active': currentSelected == 'DRAFT'}" title="Draft" (click)="mailFunc('DRAFT')"><span>Drafts</span> <span>{{emailCounts?.DRAFT}}</span></div>
            <div class="list-group-item custom-list inboxfont" [ngClass]="{'active': currentSelected == 'DELETE'}" title="Deleted" (click)="mailFunc('DELETE')"><span>Deleted</span><!--<span>2</span>--></div>
        </div>
    </div>

    <div class="right-panel col-lg-10 col-xl-10 float-right">

        <div class="email-header" *ngIf="inboxdata?.length > 0">
            
            <div class="col-md-1"></div>

             <div class="col-md-3 float-left select-all-checkbox text-left pt-2 pl-4" *ngIf="currentSelected != 'DELETE'">                
                <input type="checkbox"  style="padding: 0px; height: 22px;"  class="checkboxsize float-left" (change)="selectDeselectAll($event)">
                <span class="pl-2 deleteMail"  [ngClass]="{'disabled':deleteIds.length == 0}" (click)="deleteEmail()" ><i class="bi bi-trash"></i> <b>DELETE</b> </span>
            </div>

            <div class="col-md-4"></div>

            <div class="col-md-4 float-right text-right mb-2">
                <input type="text" name="searchText" 
                [(ngModel)]="searchText" 
                class="form-control search-email" placeholder="Search Email" 
                (keyup.enter)="searchEmail(searchText)"></div>
        </div>

        <div class="clearfix"></div>

        <div  *ngIf="inboxdata?.length > 0">
            <!-- [ngClass]="{'emailDrop': emailDropdown == true}" -->
            <div class="email-body" *ngFor="let _data of inboxdata; let i = index" id="{{i}}" >
                
                <div  style="float: left; margin-top:4px; font-size: 26px; font-weight: bold;" 
                (click)="changeClass(_data, i)" class="col-md-1 float-left" *ngIf="_data?.emailsList.length > 1"> 
                    <svg *ngIf="!_data.dropdown" xmlns="http://www.w3.org/2000/svg" width="7.483" height="13.5" viewBox="0 0 7.483 13.5">
                        <path id="Arrow" d="M509.647,92.058a.75.75,0,0,1-.531-1.28l5.455-5.47-5.455-5.47a.75.75,0,0,1,1.062-1.059l5.983,6a.75.75,0,0,1,0,1.059l-5.983,6A.748.748,0,0,1,509.647,92.058Z" transform="translate(-508.897 -78.558)" fill="#4d4f5c"/>
                    </svg>

                    <svg *ngIf="_data.dropdown" style="rotate: 90deg;" xmlns="http://www.w3.org/2000/svg" width="7.483" height="13.5" viewBox="0 0 7.483 13.5">
                        <path id="Arrow" d="M509.647,92.058a.75.75,0,0,1-.531-1.28l5.455-5.47-5.455-5.47a.75.75,0,0,1,1.062-1.059l5.983,6a.75.75,0,0,1,0,1.059l-5.983,6A.748.748,0,0,1,509.647,92.058Z" transform="translate(-508.897 -78.558)" fill="#4d4f5c"/>
                    </svg>
                      
                </div>

                <div *ngFor="let item of _data?.emailsList; let idx = i" style="overflow: hidden;" class="col-md-11 float-right">
                    
                    <div class="col-lg-1 float-left"><input type="checkbox" *ngIf="currentSelected != 'DELETE'" [(ngModel)]="item.ischecked" (change)="singleSelectCheckbox($event, item)" class="checkboxsize"></div>
                    <div class="col-lg-2 pt-2 float-left fromuser" (click)="composeEmail('edit', item)" *ngIf="item.senderName == null && item.recipientName == null">--</div>
                    <div class="col-lg-2 pt-2 float-left fromuser" (click)="composeEmail('edit', item)" *ngIf="item.folder == 'INBOX' && item.senderName != null"><b *ngIf="!item.isRead">{{item.senderName}}</b> <span *ngIf="item.isRead">{{item.senderName}}</span></div>
                    <div class="col-lg-2 pt-2 float-left fromuser" (click)="composeEmail('edit', item)" *ngIf="item.folder == 'SENT' || item.folder == 'DRAFT' || item.folder == 'DELETE' && item.recipientName != null"><b *ngIf="!item.isRead">{{item.recipientName}}</b> <span *ngIf="item.isRead">{{item.recipientName}}</span></div>
                    <div class="col-lg-6 pt-2 float-left subjectline" (click)="composeEmail('edit', item)">{{item.subject}}</div>
                    <div class="col-lg-2 pt-2 float-left text-right">{{item.dateTime | date:'MM/dd/YYYY HH:mm'}}</div>
                </div>
            </div>
        </div>



        <div class="no-data" *ngIf="inboxdata?.length == 0">
            <h2>No Record Found</h2>
        </div>

    </div>
</div>